import {useRoutes} from "react-router-dom";
import {lazy} from "react";
import {LoadComponent} from "../../../routes/LoadComponent";

const List = lazy(() => import('./List'));
const Edit = lazy(() => import('./Edit'));

const Regionals = () => {
    return useRoutes([
        {
            path: '',
            element: <LoadComponent component={List}/>
        }, {
            path: 'edit',
            element: <LoadComponent component={Edit}/>
        },
        {
            path: ':id/edit',
            element: <LoadComponent component={Edit}/>
        },
        {
            path: ':id/view',
            element: <LoadComponent component={List}/>
        }
    ]);
};


export default Regionals;
